import { PropsWithChildren } from 'react';
import { z } from 'zod';

export type SelectOrderDateV2Props = PropsWithChildren & {
  isOpen?: boolean;
  onClose?: () => void;
  intervalFrequency: number;
};

export type SelectDateChangeV2Props = {
  contractId: number;
};

export type SelectDatepickerV2Props = {
  value: Date;
  defaultValue: Date;
  onChange: (date: Date | undefined) => void;
  nextOrderDate: Date;
  className?: string;
};

export type SelectDateInfoV2Props = {
  value: Date;
  durationForSubscription: Duration;
};

export type InfoSelectDateModalAtom = {
  date: Date;
  duration: Duration;
};

export const stepSchema = z.enum(['select', 'success']);

export type Step = z.infer<typeof stepSchema>;
